<template>
  <div>
    <div class="block reports-filter">
      <div class="reports-filter__block reports-filter__block--big">
        <label class="input-label reports-filter__label">Date</label>
        <div class="reports-filter__input-group">
          <div class="reports-filter__input-group-item">
            <datepicker
              :value="dateFrom"
              input-class="input-default input-default--calendar"
              @selected="updTable">
            </datepicker>
          </div>
          <div class="reports-filter__input-group-item">
            <datepicker
              :value="dateTo"
              input-class="input-default input-default--calendar"
              @selected="updTable">
            </datepicker>
          </div>
        </div>
      </div>
      <div class="reports-filter__block">
        <label class="input-label reports-filter__label">Campaign Type</label>
        <b-form-select
          v-model="filterObj.campaign_type"
          :options="campaignTypeOptions"
          class="input-default input-default--select"
          @change="updTable">
        </b-form-select>
      </div>
      <div class="reports-filter__block">
        <label class="input-label reports-filter__label">Campaign</label>
        <select
          class="input-default input-default--select input-campaign--select"
          v-model="filterObj.campaign"
          @change="updTable">
          <option value=""></option>
          <option v-for="option in campaignOptions" v-bind:value="option.id" :key="option.id">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="reports-filter__block">
        <label class="input-label reports-filter__label">Country</label>
        <select
          class="input-default input-default--select input-country--select"
          v-model="filterObj.country"
          @change="updTable">
          <option value="1"></option>
        </select>
      </div>
      <div class="reports-filter__block reports-filter__block--auto">
        <button class="button button--primary reports-filter__button" @click="clearFilters"><i class="fa fa-repeat button__icon"></i> Clear</button>
      </div>
    </div>
    <div class="block manage-table">
      <div class="manage-table__head">
          <h3 class="manage-table__title">Selected Records: 0</h3>
          <div class="manage-table__controls">
              <button class="button button--small button--service"><i class="fa fa-columns button__icon"></i> Columns</button>
          </div>
          <div class="manage-table__display">
              <div class="manage-table__display-item manage-table__display-item--active">
                  <img src="/static/img/admin/display-01.svg" alt="" class="manage-table__display-item-img">
              </div>
              <div class="manage-table__display-item">
                  <img src="/static/img/admin/display-02.svg" alt="" class="manage-table__display-item-img">
              </div>
              <div class="manage-table__display-item">
                  <img src="/static/img/admin/display-03.svg" alt="" class="manage-table__display-item-img">
              </div>
          </div>
      </div>
      <div class="manage-table__body">
        <div class="table table--nbrus table--nbr">
          <div class="table__body">
            <b-table
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :items="reportProvider"
              :fields="fields"
              @filtered="onFiltered"
              class="table__main"
              thead-tr-class="table__row"
              tbody-tr-class="table__row"
              ref="reportTable"
            >
            </b-table>
          </div>
          <div class="table__controls">
              <b-pagination
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="table__pagination"
                first-text=""
                prev-text=""
                next-text=''
                last-text=''
              />
              <div class="table__active-pages">
                <input v-model.number="perPage" type="number" class="table__active-pages-input" />
                <div class="table__active-pages-controls">
                  <button class="table__active-pages-button table__active-pages-button--up" @click="perPage++"><i class="fa fa-caret-up"></i></button>
                  <button class="table__active-pages-button table__active-pages-button--down" @click="perPage--"><i class="fa fa-caret-down"></i></button>
                </div>
              </div>
              <div class="table__pages">{{ (currentPage === 1) ? currentPage : (currentPage * perPage - perPage) }} - {{ currentPage + perPage }} of {{ totalRows }} records</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiCall from '@/utils/api'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'ReportDate',
  components: {
    Datepicker
  },
  data () {
    return {
      fields: [
        { key: 'action', label: '', sortable: false },
        { key: 'date', label: 'DATE', sortable: true },
        { key: 'offer', label: 'Offer', sortable: true },
        { key: 'campaign', label: 'Campaign', sortable: false },
        { key: 'hourOfDay', label: 'Hour', sortable: true },
        { key: 'country', label: 'Country', sortable: true },
        { key: 'browser_type', label: 'Browser', sortable: true },
        { key: 'os_type', label: 'OS', sortable: true },
        { key: 'keyword', label: 'Keyword', sortable: true },
        { key: 'site_domain', label: 'Domain', sortable: true },
        { key: 'pubsubid', label: 'SubID', sortable: true },
        { key: 'adv_responses', label: 'Ad Responses', sortable: true },
        { key: 'adv_clicks', label: 'Clicks', sortable: true },
        { key: 'adv_cost', label: 'Cost', sortable: true },
        { key: 'adv_cpc', label: 'SubID', sortable: true },
        { key: 'adv_cpv', label: 'CPV', sortable: true }
      ],
      perPageStr: '',
      sortBy: 'date',
      sortDesc: false,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      filter: 'null',
      campaignSelected: null,
      campaignOptions: [],
      campaignTypeSelected: null,
      campaignTypeOptions: [
        {text: '', value: ''},
        {text: 'CPC', value: 'CPC'},
        {text: 'CPV', value: 'CPV'},
        {text: 'NATIVE', value: 'NATIVE'},
        {text: 'DISPLAY', value: 'DISPLAY'}
      ],
      countrySelected: null,
      countryOptions: [],
      dateFrom: new Date(2018, 0, 1),
      dateTo: new Date(),
      dateRange: '',
      filterObj: {
        campaign_type: 'null',
        campaign: 'null',
        offer: 'null',
        country: 'null'
      }
    }
  },
  methods: {
    reportProvider (ctx) {
      this.dateRange = moment(this.dateFrom).format('YYYY-MM-d') + '_' + moment(this.dateTo).format('YYYY-MM-d')
      ctx.filter = 'date:' + this.dateRange + ';'

      for (var key in this.filterObj) {
        if (this.filterObj[key] !== 'null') {
          ctx.filter += key + ':' + this.filterObj[key] + ';'
        }
      }

      let promise = apiCall({controller: 'CpmAdvertiserReports/date', data: { ctx: ctx }, method: 'GET'})
      return promise.then((data) => {
        this.totalRows = Object.keys(data.data.response).length
        let items = Object.values(data.data.response)
        return (items || [])
      })
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    updTable () {
      // this.filter = 'test'
      // this.$refs.reportTable.refresh()
    },
    clearFilters () {
      for (var key in this.filterObj) {
        this.filterObj[key] = 'null'
      }
    }
  },
  mounted: function () {
    apiCall({controller: 'Campaign', data: { getparam: 'columns=id,name' }, method: 'GET'})
      .then(resp => {
        this.campaignOptions = resp.data.response
      })
      .catch(err => {
        console.log(err)
      })
  }
}
</script>

<style>
.input-default--calendar{
  width: 140px;
  padding-left: 35px;
}
.input-campaign--select{
  width: 120px;
}
tr.table__row th{
    padding: .8rem 1.5rem;
    color: #969CAA;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-weight: 600;
    text-align: left;
    background-color: #E8ECF3;
    border-right: solid .1rem #DAE1ED;
    border-bottom: solid .1rem #DAE1ED;
}
tr.table__row th.sorting::before, tr.table__row th.sorting::after{
  top: 1.5rem;
}
.manage-filter__controls-item{
  padding: 0.7rem 0.5rem 0.6rem 0.5rem;
}
.input-default{
  padding: .9rem 1rem .7rem;
}
.input-default--search{
  padding-left: 3.5rem;
}
.button{
  letter-spacing: normal;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/advertiser/report/index.vue